<template>
  <WeContainer card="">
    <WeCard class="mb-3">
      <h5 class="custom-card-title">
        <i class="fas fa-user"></i>
        <span>Üye Bazlı Satış Raporu</span>
      </h5>
    </WeCard>
    <WeTableSearch
      v-on:search="onSearch"
      v-on:clear="onFilterClear"
      v-bind:show-icon="false"
      header-class="bg-white text-dark"
      header-text-class="text-dark h6"
      v-bind:show-on-load="true"
    >
      <div slot="detail-search">
        <div class="row mb-3">
          <!-- Left -->
          <div class="col-12 col-lg-6">
            <!-- Created At -->
            <div class="d-block mb-3">
              <WeRowInput
                form="date"
                size="sm"
                label="Tarih"
                placeholder="Tarih"
                v-bind:date-range="true"
                v-model="filter.dates"
                selected-shortcut="thisMonth"
              />
            </div>
            <!-- Created At -->
          </div>
          <!-- Left -->
        </div>
      </div>
    </WeTableSearch>
    <WeCard>
      <div class="position-relative" style="min-height: 250px" v-if="loading">
        <WeLoading />
      </div>
      <div v-else v-bind:id="printConfig.id">
        <span v-print="printConfig" ref="printButton"> </span>
        <div class="text-center print">
          <h5 class="font-weight-bold">{{ getFileName }}</h5>
        </div>
        <WeTable
          v-bind:index="false"
          v-bind:columns="columns"
          v-bind:data="list"
          v-bind:actions="[]"
          v-bind:exportables="exportables"
          v-on:on-export="onExport"
          v-bind:paginatable="paginatable"
          v-bind:pageDetails="pageDetails"
          v-bind:limitable="limitable"
          v-bind:searchable="searchable"
        />
      </div>
    </WeCard>
  </WeContainer>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Sale",
  data() {
    return {
      loading: false,
      modalLoading: true,
      showModal: false,
      paginatable: true,
      pageDetails: true,
      limitable: true,
      searchable: true,
      list: [],
      columns: [
        { name: "current_code", th: "Hesap Kodu", type: "string" },
        { name: "full_name", th: "Ad Soyad", type: "string" },
        { name: "email", th: "E-Posta Adresi", type: "string" },
        { name: "cart_amount", th: "Alışveriş Adeti", type: "integer" },
        { name: "total_price", th: "Toplam Tutar", type: "currency" },
      ],
      filter: {
        dates: {
          start: null,
          end: null,
        },
        order_status: null,
      },
      statusOptions: [
        {
          id: "1",
          name: "Aktif",
        },
        {
          id: "0",
          name: "Pasif",
        },
      ],
      exportables: ["excel", "pdf"],
      printConfig: {
        id: "MemberSaleReport",
        popTitle: "Üye Bazlı Satış Raporu",
      },
    };
  },
  methods: {
    ...mapActions("reports", ["makeSearch", "show"]),
    ...mapActions("order", ["getOrderTypes"]),
    ...mapActions("tableExport", ["exportData"]),
    getFilter(copyDates = true) {
      let copy = helper.clone(this.filter);
      copy.dates = [];

      if (
        copyDates &&
        this.filter.dates &&
        this.filter.dates.start &&
        this.filter.dates.end
      ) {
        Object.entries(this.filter.dates).forEach(([key, value]) => {
          if (value) {
            copy.dates.push(value);
          }
        });
      } else {
        delete copy.dates;
      }

      return copy;
    },
    onSearch() {
      this.loading = true;
      this.makeSearch({
        routeKey: "memberSale",
        filter: this.getFilter(),
        onSuccess: (result) => {
          this.list = result.data.items;
          this.loading = false;
        },
      });
    },
    onFilterClear() {
      this.filter = {
        dates: {
          start: null,
          end: null,
        },
        is_active: null,
      };
      this.onSearch();
    },
    onExport(data) {
      if (this.list && this.list.length) {
        if (data.name !== "print") {
          let fileName = "Üye Bazlı Satış Raporu";

          if (
            this.filter.dates &&
            this.filter.dates.start &&
            this.filter.dates.end
          ) {
            let startDate = new Date(
              this.filter.dates.start
            ).toLocaleDateString("tr-TR");
            let endDate = new Date(this.filter.dates.end).toLocaleDateString(
              "tr-TR"
            );

            fileName = startDate + " - " + endDate + " - " + fileName;
          }

          this.exportData({
            route: "report/members/sale/export",
            exportable: data,
            fileName: fileName,
            filter: {
              ...this.getFilter(),
              type: data.name,
            },
          });
        } else {
          this.setPrintableSettings(true);
          this.$refs.printButton.click();

          setTimeout(() => {
            this.setPrintableSettings(false);
          }, 100);
        }
      } else {
        this.$swal({
          title: "Dışarı aktarılacak veya Yazdırılacak veri mevcut değil",
          icon: "warning",
          confirmButtonText: "Tamam",
        });
      }
    },
    setPrintableSettings(print = false) {
      this.paginatable = !print;
      this.pageDetails = !print;
      this.limitable = !print;
      this.searchable = !print;

      this.list.sort();
    },
  },
  computed: {
    ...mapState(["order"]),
    orderStatusHint() {
      return `Varsayılan Sipariş Durumu
        <ul class="text-left mb-0">
          <li class="font-weight-bold">Ödeme Yapıldı</li>
          <li class="font-weight-bold">Onaylandı</li>
          <li class="font-weight-bold">Kargo Hazırlanıyor</li>
          <li class="font-weight-bold">Kargoya Verildi</li>
          <li class="font-weight-bold">Teslim Edildi</li>
        </ul>`;
    },
    getFileName() {
      const defaultName = "Üye Bazlı Satış Raporu";
      let result = "";

      if (
        this.filter.dates &&
        this.filter.dates.start &&
        this.filter.dates.end
      ) {
        let startDate = this.filter.dates.start;
        let endDate = this.filter.dates.end;

        startDate = new Date(startDate).toLocaleDateString("tr-TR");
        endDate = new Date(endDate).toLocaleDateString("tr-TR");

        result = `${startDate} - ${endDate} ${defaultName}`;
      } else {
        result = defaultName;
      }

      return result;
    },
  },
  mounted() {
    this.getOrderTypes();
    this.onSearch();
  },
};
</script>